// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2dLXK","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3_vGY"};